"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../../redux/state");
const navigationReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_NAVIGATION_PRODUCT_CATEGORY' }, _action => state.update(state_1.stateKeys.navigationProductCategory, _state => ({
    ..._state,
    value: _action.payload
})))
    .exhaustive();
exports.navigationReducer = navigationReducer;
//# sourceMappingURL=reducer.js.map